// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {Panel} from '../../../comp/panel';
import {Routed_tabs} from '../../../comp/tabs';
import {Referral, Referral_bvpn} from '../../../features/referral';
import {get_path} from '../util.js';
import * as cns from './referees.module.less';

const TAB_ITEMS = [{
    to: get_path('/referrals/earnapp'),
    label: 'EarnApp',
    component: Referral
}, {
    to: get_path('/referrals/bvpn'),
    label: 'BrightVPN',
    component: Referral_bvpn,
}];

function Content(){
    return <Switch>
      {TAB_ITEMS.map(item=><Route key={item.to} path={item.to} exact
        component={item.component}/>)}
      <Redirect to={TAB_ITEMS[0].to}/>
    </Switch>;
}

export function Referees(){
    return <div className={cns.root}>
      <Routed_tabs items={TAB_ITEMS} size="m"/>
      <Panel>
        <Content/>
      </Panel>
    </div>;
}
